import { ofType } from "redux-observable";
import { from } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";
import { selectActiveDiscountEventInfoByEventType } from "../../../selectors/selectEventInfo";
import { actionDiscountEventActionButtonHide, actionDiscountEventSelectEvent, TypeActionDiscountEvent, } from "../actionDiscountEvent";
export var epicDiscountEventActionButtonClick = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionDiscountEvent.ActionButtonClick), map(function (action) {
        return selectActiveDiscountEventInfoByEventType(state$.value, action.eventType);
    }), filter(function (activeDiscount) {
        return activeDiscount !== undefined && activeDiscount.proto.eventId !== undefined;
    }), switchMap(function (activeDiscount) {
        return from([
            actionDiscountEventSelectEvent(activeDiscount.proto.eventId),
            actionDiscountEventActionButtonHide(activeDiscount.proto.eventId),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/epics/epicDiscountEventActionButtonClick.ts
// module id = 1831
// module chunks = 3